import React from 'react';

interface ToggleProps {
  label: string;
  enabled: boolean;
  onChange: () => void;
}

const Toggle: React.FC<ToggleProps> = ({ label, enabled, onChange }) => {
  return (
    <label className="flex items-center cursor-pointer">
      <span className="mr-3 text-sm font-medium text-gray-700">{label}</span>
      <div className="relative">
        <input type="checkbox" className="sr-only" checked={enabled} onChange={onChange} />
          <div
              className={`block w-14 h-8 rounded-full ${
                  enabled ? 'bg-blue-600' : 'bg-gray-200'
              }`}
          ></div>
        <div
          className={`dot absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${
            enabled ? 'translate-x-6 bg-blue-600' : ''
          }`}
        ></div>
      </div>
    </label>
  );
};

export default Toggle;